import {useWorkOrder, SideCardComponentProps, WorkOrder} from '@domain/work-orders'
import {ContentBox} from '@hconnect/common/components/ContentBox'
import {useUpmPlantTimezone} from '@hconnect/upm'
import CloseIcon from '@mui/icons-material/Close'
import {Box, Typography} from '@mui/material'
import {EventCreator, WorkOrders} from '@widgets/shift-event-details'

import {SIDE_CARD_MIN_HEIGHT_IN_PX} from '../consts/sideCard.consts'

import {WorkOrderDetailsGrid} from './WorkOrderDetailsGrid'

export const WorkOrderSideCard: SideCardComponentProps<WorkOrder> = ({
  item: worksOrder,
  itemId: worksOrderId,
  doClose,
  plantId
}) => {
  const timezone = useUpmPlantTimezone(plantId)

  const {data} = useWorkOrder({
    plantId,
    workOrderId: worksOrderId,
    options: {
      enabled: !worksOrder && !!worksOrderId
    }
  })
  const item = worksOrder || data

  if (!item) {
    return (
      <ContentBox
        data-test-id="sideCard-spinner"
        isLoading
        minHeight={SIDE_CARD_MIN_HEIGHT_IN_PX}
        mode="max100PercentOfParentHeight"
      />
    )
  }

  return (
    <ContentBox
      data-test-id="events-details"
      mode="max100PercentOfParentHeight"
      bodyWithPadding
      title={
        <Typography
          component="span"
          variant="h2"
          sx={{textTransform: 'none'}}
          data-test-id="event-detail-title"
          display="flex"
          alignItems="center"
        >
          {item?.title || item.id}
        </Typography>
      }
      afterTitle={
        <Box display="flex" alignItems="center">
          <Typography
            sx={{
              p: 1.75,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer'
            }}
          >
            <CloseIcon onClick={doClose} color="primary" data-test-id="events-details-close" />
          </Typography>
        </Box>
      }
      headerSx={{pb: 0}}
    >
      <EventCreator
        plantId={plantId}
        name={item.createdBy.name}
        created={item.createdAt}
        modifiedBy={item.updatedBy?.name}
      />
      {item.pmNotificationId && (
        <WorkOrders plantId={plantId} notificationId={item.pmNotificationId} />
      )}
      <WorkOrderDetailsGrid item={item} timezone={timezone} />
    </ContentBox>
  )
}
